@if (on === 'form' && !control.field.condensed) {
  <mat-form-field class="date-time-field" floatLabel="always" style="height: 74px;">
    <mat-label>{{control.field.label}}</mat-label>
    <div class="date-time-row" [class.locked]="!isEditable()">
      <input class="date-input"
        [matDatepicker]="datePicker"
        [value]="control.value"
        (dateChange)="applyChosenDateKeepingTimeOfDay($event)"
        (click)="$event.stopPropagation()"
        [disabled]="control.disabled"
        [readonly]="!isEditable()"
        id="{{control.field.name}}-dateTimeField-date"
        placeholder="DD/MM/YYYY"
        autocomplete="off">
      @if (isEditable()) {
        <mat-datepicker-toggle class="compact-toggle" [for]="datePicker">
          <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
        </mat-datepicker-toggle>
      }
      <input matInput class="time-input"
        [matTimepicker]="timePicker"
        [matTimepickerOpenOnClick]="false"
        [formControl]="control"
        [readonly]="!isEditable()"
        id="{{control.field.name}}-dateTimeField-time"
        placeholder="HH:MM"
        autocomplete="off">
      <div class="zone-over-clock">
        <span class="time-zone">{{getTimeZoneName()}}</span>
        @if (isEditable()) {
          <mat-timepicker-toggle class="compact-toggle" [for]="timePicker">
            <mat-icon matTimepickerToggleIcon>schedule</mat-icon>
          </mat-timepicker-toggle>
        }
      </div>
    </div>
    <mat-datepicker #datePicker></mat-datepicker>
    <mat-timepicker #timePicker interval="15m"></mat-timepicker>
    <mat-error style="margin-top: -5px">
      <app-form-error [control]="control"></app-form-error>
    </mat-error>
  </mat-form-field>
}

@if (on === 'form' && control.field.condensed) {
    <div class="condensed">
        <div class="condensed-label">{{control.field.label}}</div>
        <div class="condensed-value">
            <span [attr.data-field]="control.field.name" [matTooltip]="getCurrentFullDate()">{{relativeToNowText}}</span>
            <div class="condensed-hint">
                @if (control.field.hint) {
                    <mat-icon [matTooltip]="control.field.hint" matTooltipPosition="above">help</mat-icon>
                }
            </div>
        </div>
    </div>
}

@if (on !== 'form') {
  @if (isEditable()) {
    <div class="grid-date-time" [attr.data-field-name]="control.field.name">
      <input class="grid-date-part"
        [matDatepicker]="gridDatePicker"
        [value]="control.value"
        (dateChange)="applyChosenDateKeepingTimeOfDay($event)"
        placeholder="DD/MM/YYYY"
        autocomplete="off">
      <mat-datepicker-toggle [for]="gridDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #gridDatePicker></mat-datepicker>
      <input class="grid-time-part"
        [matTimepicker]="gridTimePicker"
        [formControl]="control"
        placeholder="HH:MM"
        autocomplete="off">
      <mat-timepicker #gridTimePicker interval="15m"></mat-timepicker>
    </div>
  } @else {
    <span [matTooltip]="getCurrentFullDate()">{{relativeToNowText}}</span>
  }
}
